export default __webpack_public_path__ + "static/media/weapon4.3fa13382.png";